import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const SidebarNavigation = ({ isCollapsed = false, onToggle }) => {
  const location = useLocation();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const navigationItems = [
    {
      label: 'داشبورد',
      path: '/dashboard-overview',
      icon: 'LayoutDashboard',
      tooltip: 'مشاهده وضعیت کلی و آمار درخواست‌ها',
      status: 'active',
    },
    {
      label: 'درخواست جدید',
      path: '/new-request-form',
      icon: 'Plus',
      tooltip: 'ایجاد درخواست جدید برای سند حقوقی',
      status: 'active',
    },
    {
      label: 'مدیریت درخواست‌ها',
      path: '/requests-management',
      icon: 'FileText',
      tooltip: 'مشاهده و مدیریت تمام درخواست‌های شما',
      status: 'active',
    },
    {
      label: 'پرداخت‌ها',
      path: '/payments',
      icon: 'CreditCard',
      tooltip: 'تاریخچه پرداخت‌ها و صورتحساب‌ها',
      status: 'deActive',
    },
  ];

  const handleLogout = () => {
    // Logout logic would be implemented here
    console.log('Logging out...');
  };

  return (
    <aside
      className={`fixed top-0 right-0 h-full bg-card border-l border-border z-40 transition-all duration-300 ease-in-out ${
        isCollapsed ? 'w-16' : 'w-80'
      } lg:w-80 lg:translate-x-0 ${
        isCollapsed ? 'translate-x-full lg:translate-x-0' : 'translate-x-0'
      }`}>
      <div className="flex flex-col h-full">
        {/* Logo Section */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3 space-x-reverse">
            {/* <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Scale" size={24} color="white" />
            </div> */}
            {!isCollapsed && (
              <div>
                <h1 className="text-lg font-semibold text-foreground">
                  ایرانداد
                </h1>
                <p className="text-sm text-muted-foreground">پنل کاربری</p>
              </div>
            )}
          </div>

          {/* Mobile Toggle Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggle}
            className="lg:hidden">
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* User Profile Section */}
        <div className="p-6 border-b border-border">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
              <Icon name="User" size={20} color="white" />
            </div>
            {!isCollapsed && (
              <div className="flex-1">
                <h3 className="font-medium text-foreground">احمد محمدی</h3>
                <p className="text-sm text-muted-foreground">پلن طلایی</p>
                <div className="flex items-center mt-1">
                  <Icon name="Coins" size={14} className="text-warning ml-1" />
                  <span className="text-sm text-warning font-medium">
                    ۱۲ اعتبار
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Navigation Items */}
        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {navigationItems?.map((item) => (
              <li key={item?.path}>
                <NavLink
                  to={item?.path}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 space-x-reverse px-4 py-3 rounded-lg transition-all duration-150 ease-out group relative ${
                      isActive
                        ? 'bg-primary text-primary-foreground shadow-sm'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    }`
                  }
                  title={isCollapsed ? item?.tooltip : ''}>
                  <Icon
                    name={item?.icon}
                    size={20}
                    className={
                      location?.pathname === item?.path
                        ? 'text-primary-foreground'
                        : ''
                    }
                  />
                  {/* {!isCollapsed && ( */}
                  <span className="font-medium">{item?.label}</span>
                  {/* )} */}

                  {/* Tooltip for collapsed state */}
                  {isCollapsed && (
                    <div className="absolute right-full mr-2 px-2 py-1 bg-popover text-popover-foreground text-sm rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none whitespace-nowrap z-50">
                      {item?.label}
                    </div>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer Section */}
        <div className="p-4 border-t border-border">
          <div className="space-y-2">
            <Button
              variant="ghost"
              className="w-full justify-start space-x-3 space-x-reverse"
              onClick={() => setUserMenuOpen(!userMenuOpen)}>
              <Icon name="Settings" size={20} />
              {!isCollapsed && <span>تنظیمات</span>}
            </Button>

            <Button
              variant="ghost"
              className="w-full justify-start space-x-3 space-x-reverse text-destructive hover:text-destructive hover:bg-destructive/10"
              onClick={handleLogout}>
              <Icon name="LogOut" size={20} />
              {!isCollapsed && <span>خروج</span>}
            </Button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SidebarNavigation;
